/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AuthData, ManualItem } from '../types';
import LoadingComponent from '../components/LoadingComponent';
import PdfViewer from '../components/PdfViewer';
import HtmlZipViewer from '../components/HtmlZipViewer';
// import LoadingComponent from './LoadingComponent';

const ManualViewerPage = ({loginData, manualItems}: {loginData: null | AuthData, manualItems: ManualItem[]}) => {
  const { id } = useParams();
  const [manual, setManual] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchManual = async () => {
      if (!loginData?.UserId) {
        setError("Acceso restringido.");
        return;
      }
      if (id === manual?.manualId) {
        return;
      }
      try {
        setLoading(true);
        // const response = await getManualById(
        //     `${loginData?.UserId}`,
        //     `${id}`
        // );
        setManual(manualItems.find(m => m.manualId === id));
      } catch (err) {
        setError('Error al cargar el manual');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id && !loading) {
      fetchManual();
    }
  }, [id]);

  if (!manual) return <div>Manual no encontrado</div>;
  if (error) return <div>{error}</div>;
  if (loading) return <LoadingComponent loadingText="Cargando manual..." />;

  return (
    <div style={{ padding: '20px' }}>
      <h1>{manual.name}</h1>
      {/* <ManualViewer 
        key={manual.manualId}
        fileUrl={`${manual.signedUrl}&test=${Date.now()}`} 
        fileType={manual.fileType} 
      /> */}
      {manual.fileType === 'pdf' &&
        <PdfViewer 
          key={manual.manualId}
          fileUrl={`${manual.signedUrl}`}
        />
      }
      {manual.fileType === 'html-zip' &&
        <HtmlZipViewer 
          key={manual.manualId}
          fileUrl={`${manual.signedUrl}`}
        />
      }
    </div>
  );
};

export default ManualViewerPage;